"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var coreConfig = {
    API_BASE_URL: process.env.REACT_APP_API_ENDPOINT || 'https://h5.congmingpai.com/api',
    DEBUG: process.env.DEBUG || false,
    FAKE_TOKEN: process.env.FAKE_TOKEN || undefined,
    CDN_DOMAIN: "https://cdn.frontend.congmingpai.com",
    AUTO_COMPRESSION_SUFFIX: '?x-oss-process=image/auto-orient,1/quality,q_70',
    AUTO_COMPRESSION_WEBP_SUFFIX: '?x-oss-process=image/auto-orient,1/quality,q_70/format,webp',
    WEBP_SUFFIX: '?x-oss-process=image/format,webp',
};
exports.coreConfig = coreConfig;
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/config.js
// module id = 448
// module chunks = 0